"use client";

import { useState, useEffect } from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Leadership() {
  const [isZh, setIsZh] = useState(false);
  useEffect(() => {
    const lang = localStorage.getItem("elite-language");
    if (lang === "zh-Hant") {
      setIsZh(true);
    }
  }, []);
  const {
    ref: headRef,
    isVisible: headVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const {
    ref: gridRef,
    isVisible: gridVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const fixers = [{
    name: "KM",
    specialty: isZh ? "高級營運總監" : "Senior Operation Director",
    favorite: isZh ? "— 20年精密工程經驗" : "— 20 years of precision engineering"
  }, {
    name: "Emma",
    specialty: isZh ? "營運經理" : "Operation Manager",
    favorite: isZh ? "— 嚴格遵循全球安全標準" : "— ensuring global safety standards"
  }, {
    name: "Mark",
    specialty: isZh ? "高級技術經理" : "SENIOR TECHNICAL MANAGER",
    favorite: isZh ? "— 優化工廠生產效能" : "— optimizing factory throughput"
  }, {
    name: "Ken",
    specialty: isZh ? "高級銷售經理" : "Senior Sales Manager",
    favorite: isZh ? "— 無縫全球物流支援" : "— seamless global logistics"
  }];
  return <section data-section-id="20544" id="leadership-team" className="relative bg-background text-foreground py-24 md:py-36 overflow-hidden">
      <div className="pointer-events-none absolute inset-0 opacity-[0.03]" style={{
      backgroundImage: "url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='40' height='40'><rect width='40' height='40' fill='none' stroke='%23000' stroke-width='0.5'/></svg>\")"
    }} aria-hidden="true" />

      <div className="relative mx-auto max-w-[1240px] px-6 md:px-10 lg:px-16">
        <div ref={headRef} className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-12 mb-16 md:mb-20">
          <div className={`lg:col-span-7 transition-all duration-700 ease-out ${headVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
            <span className="inline-block font-default text-[0.75rem] font-medium tracking-[0.15em] uppercase mb-5 text-foreground">
              {isZh ? "領導團隊" : "OUR LEADERSHIP"}
            </span>
            <h2 className="font-default font-semibold text-foreground leading-[1.1] tracking-[-0.02em]" style={{
            fontSize: "clamp(2rem, 4.2vw, 3.75rem)"
          }}>
              {isZh ? <>
                  引領{" "}
                  <span className="relative inline-block text-primary">
                    全球製造
                  </span>{" "}
                  的專業團隊。
                </> : <>
                  The{" "}
                  <span className="relative inline-block text-primary">
                    experts
                  </span>{" "}
                  driving global manufacturing.
                </>}
            </h2>
            <p className="mt-6 font-default text-foreground/80 max-w-xl" style={{
            fontSize: "1.25rem",
            lineHeight: 1.6
          }}>
              {isZh ? "Elite Group Corporation Limited 由資深行業專家領導，致力於在全球玩具與消費品市場中追求精準、合規與創新。" : "Elite Group Corporation Limited is led by industry veterans dedicated to precision, compliance, and innovation in the global toy and consumer goods market."}
            </p>
          </div>

          <div className={`lg:col-span-5 lg:pl-6 flex flex-col items-start lg:items-end justify-end relative transition-all duration-700 ease-out delay-150 ${headVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
            <p className="font-mono text-foreground/70 mb-3 lg:text-right" style={{
            fontSize: "1.25rem",
            lineHeight: 1.2
          }}>
              {isZh ? "與我們的團隊合作 " : "partner with our team \u2766"}
            </p>

            <Link to="#" className="group relative inline-flex items-center gap-2 font-default font-semibold text-foreground bg-primary px-8 py-4">
              <span className="relative">{isZh ? "聯絡我們" : "Contact Us"}</span>
              <ArrowRight className="size-4 transition-transform duration-300 group-hover:translate-x-1" />
            </Link>
          </div>
        </div>

        <div ref={gridRef} className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 sm:gap-7 lg:gap-7">
          {fixers.map((fixer, i) => <div key={i} data-index={i} className={`group relative bg-background border border-border p-0 transition-all duration-300 ease-out ${gridVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
          transitionDelay: gridVisible ? `${i * 80}ms` : "0ms"
        }}>
              <div className="aspect-[4/5] bg-[#1A1A1A] border border-[#F8BA16] flex items-center justify-center p-8 overflow-hidden">
                <img src="https://elite-corpltd.com/wp-content/uploads/2026/06/Elite-Group-Logo-1.png" alt="Elite Group Corporation Limited logo" className="w-36 max-w-full max-h-16 object-contain" />
              </div>
              <div className="p-6">
                <h3 className="font-default font-semibold text-foreground leading-tight" style={{
              fontSize: "1.5rem"
            }}>
                  {fixer.name}
                </h3>
                <p className="font-default text-foreground/60 mt-2 uppercase tracking-wider !text-xs">
                  {fixer.specialty}
                </p>
                <p className="font-mono mt-4 leading-tight text-[0.85rem] text-primary">
                  {fixer.favorite}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}